/**
 * Stream Module
 *
 * Shared utilities and errors for EventStream and BlockStream.
 *
 * @module stream
 */

export {
	BlockRangeTooLargeError,
	BlockStreamAbortedError,
	EventStreamAbortedError,
	StreamAbortedError,
	UnrecoverableReorgError,
} from "./errors.js";
